module.exports = __webpack_public_path__ + "static/media/journolist-logo.e11117eb.png";